<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (currentPage) {
  <div class="modal-header">
    <h5 class="modal-title">
      <span [xdaTranslate]="currentPage.title"></span>
      @if (totalPages > 1) {
        <span> (<span [textContent]="getPageOfText()"></span>)</span>
      }
    </h5>
  </div>
}
@if (currentPage) {
  <div class="modal-body" tabindex="-1">
    <label [xdaTranslate]="currentPage.desc"></label>
    <div class="tos-container">
      @if (!currentPage.isHTML) {
        <pre [textContent]="currentPage.text"></pre>
      }
      @if (currentPage.isHTML) {
        <pre [innerHTML]="currentPage.text"></pre>
      }
    </div>
    @if (!guestEula) {
      <div style="margin-top: 20px">
        <xrx-checkbox
          class="tos-checkbox"
          [label]="'SDE_I_AGREE1'"
          [(checkBoxValue)]="currentPage.accepted"
          [name]="'tos-checkbox'"></xrx-checkbox>
      </div>
    }
  </div>
}
@if (currentPage) {
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
      </button>
    </div>
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-primary"
        [disabled]="!currentPage.accepted"
        (click)="next()">
        <span class="btn-label" [xdaTranslate]="nextButtonText"></span>
      </button>
    </div>
  </div>
}
